import "./App.css";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  useHistory,
} from "react-router-dom";
import Scroll from "./components/Scroll/Scroll";
import Home from "../src/components/Home/Home";
import Login from "../src/components/Login/Login";
import Register from "../src/components/Login/Register";
import Forgot from "./components/Login/Forgot";
import Reset from "./components/Login/Reset";
import Dashboard from "../src/components/Account/Dashboard";
import Country from "../src/components/Country/Country";
import Payment from "../src/components/Payment/Payment";
import Thanks from "../src/components/Thanks/Thanks";
import Faq from "./components/Account/Faq/Faq";
import Settings from "./components/Account/Settings/Settings";
import PlanATrip from "./components/Account/Plan A Trip/PlanATrip";
import Transactions from "./components/Account/Transactions/Transactions";
import MyApplications from "./components/Account/My Applications/MyApplications";
import TransactionsPayment from "./components/Account/Transactions/TransactionsPayment";
import TransactionsSuccess from "./components/Account/Transactions/TransactionsSuccess";
import PlanATripProcess from "./components/Account/Plan A Trip/PlanATripProcess";
import PlanATripPayment from "./components/Account/Plan A Trip/PlanATripPayment";
import PlanATripSuccess from "./components/Account/Plan A Trip/PlanATripSuccess";
import ApplicationCenter from "./components/Account/My Applications/ApplicationCenter";
import UploadPassport from "./components/Account/My Applications/UploadPassport";
import PassportInfo from "./components/Account/My Applications/PassportInfo";
import OtherInfo from "./components/Account/My Applications/OtherInfo";
import TravelInfo from "./components/Account/My Applications/TravelInfo";
import UploadOtherInfo from "./components/Account/My Applications/UploadOtherInfo";
import Review from "./components/Account/My Applications/Review";
import ThanksApp from "./components/Account/My Applications/ThanksApp";
import MoreTravellers from "./components/Account/My Applications/MoreTravellers";
import ReviewSubmitted from "./components/Account/My Applications/ReviewSubmitted";
import ViewSaved from "./components/Account/My Applications/ViewSaved";
import ReviewSaved from "./components/Account/My Applications/ReviewSaved";
import Countries from "./components/Account/Countries/Countries";

import Protected from "./Protected";

function App() {
  return (
    <div>
      <Router>
        <Scroll />
        <Switch>
        <Route path="/dashboard/countries">
            <Protected Cmp={Countries} />
          </Route>

          <Route path="/dashboard/my-applications/:id/review-saved-application">
            <Protected Cmp={ReviewSaved} />
          </Route>
          <Route path="/dashboard/my-applications/:id/saved-applications">
            <Protected Cmp={ViewSaved} />
          </Route>
          <Route path="/dashboard/my-applications/:id/review-submitted-application">
            <Protected Cmp={ReviewSubmitted} />
          </Route>

          <Route path="/dashboard/my-applications/:id/travellers">
            <Protected Cmp={MoreTravellers} />
          </Route>

          <Route path="/dashboard/my-applications/:id/submitted-successfully">
            <Protected Cmp={ThanksApp} />
          </Route>

          <Route path="/dashboard/my-applications/:id/review-application">
            <Protected Cmp={Review} />
          </Route>

          <Route path="/dashboard/my-applications/:id/upload-other-docs">
            <Protected Cmp={UploadOtherInfo} />
          </Route>

          <Route path="/dashboard/my-applications/:id/travel-info">
            <Protected Cmp={TravelInfo} />
          </Route>

          <Route path="/dashboard/my-applications/:id/other-info">
            <Protected Cmp={OtherInfo} />
          </Route>

          <Route path="/dashboard/my-applications/:id/passport-info">
            <Protected Cmp={PassportInfo} />
          </Route>

          <Route path="/dashboard/my-applications/:id/upload-passport">
            <Protected Cmp={UploadPassport} />
          </Route>

          <Route path="/dashboard/my-applications/application-center/:id">
            <Protected Cmp={ApplicationCenter} />
          </Route>

          <Route path="/dashboard/plan-a-trip/payment/successful">
            <Protected Cmp={PlanATripSuccess} />
          </Route>

          <Route path="/dashboard/plan-a-trip/payment">
            <Protected Cmp={PlanATripPayment} />
          </Route>

          <Route path="/dashboard/plan-a-trip/processing-time">
            <Protected Cmp={PlanATripProcess} />
          </Route>

          <Route path="/dashboard/transactions/payment/successful">
            <Protected Cmp={TransactionsSuccess} />
          </Route>

          <Route path="/dashboard/transactions/payment/:id">
            <Protected Cmp={TransactionsPayment} />
          </Route>

          <Route path="/dashboard/my-applications">
            <Protected Cmp={MyApplications} />
          </Route>

          <Route path="/dashboard/transactions">
            <Protected Cmp={Transactions} />
          </Route>

          <Route path="/dashboard/plan-a-trip">
            <Protected Cmp={PlanATrip} />
          </Route>

          <Route path="/dashboard/faq">
            <Protected Cmp={Faq} />
          </Route>

          <Route path="/dashboard/settings">
            <Protected Cmp={Settings} />
          </Route>

          <Route path="/dashboard/home">
            <Protected Cmp={Dashboard} />
          </Route>

          <Route path="/payment/thanks" exact>
            <Thanks />
          </Route>

          <Route path="/countries/:id/payment" exact>
            <Payment />
          </Route>

          <Route path="/countries/:id">
            <Country />
          </Route>

          <Route path="/reset-password/">
            <Reset />
          </Route>

          <Route path="/forgot-password">
            <Forgot />
          </Route>

          <Route path="/register">
            <Register />
          </Route>

          <Route path="/login">
            <Login />
          </Route>

          <Route exact path="/">
            <Home />
          </Route>
        </Switch>
      </Router>
    </div>
  );
}

export default App;

// function DashboardNavigate() {

//   const history = useHistory()

//   history.push("/dashboard/home")

//   return(null)
// }
